var React = require('react');

function Caret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L6 5L11 1","stroke":"#004B87","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Caret.defaultProps = {"width":"12","height":"6","viewBox":"0 0 12 6","fill":"none"};

module.exports = Caret;

Caret.default = Caret;
